import { ReactNode } from 'react';
import { useBreakpoint } from '@/hooks/useBreakpoint';
import { DepartmentTree } from './Departments/DepartmentTree';
import { SelectedDepartment } from '@/types/selectedDepartment';

interface DepartmentPickerProps {
  title?: ReactNode;
  suggestedDepartmentId?: string;
  onSelect: (department: SelectedDepartment) => void;
  nonSelectableDepartments?: string[];
  enabledDepartments?: string[];
  icons?: Record<string, ReactNode>;
  dontHighlightSelectedDepartment?: boolean;
}

export const DepartmentPicker = ({
  title,
  suggestedDepartmentId,
  onSelect,
  nonSelectableDepartments,
  enabledDepartments,
  icons,
  dontHighlightSelectedDepartment,
}: DepartmentPickerProps) => {
  const isMobile = useBreakpoint(768);

  return (
    <div className="flex w-full flex-col items-center">
      {title && <span className="font-bold">{title}</span>}
      <DepartmentTree
        selectedDepartmentId={suggestedDepartmentId}
        mobileView={isMobile}
        onChange={onSelect}
        showFilter={false}
        disabledDepartments={nonSelectableDepartments}
        enabledDepartments={enabledDepartments}
        icons={icons}
        dontHighlightSelectedDepartment={dontHighlightSelectedDepartment}
      />
    </div>
  );
};
